export class TblLeadMedium {
    refNo:number;
    leadMediumName:string
    leadMediumType:string;
}